<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon v-if="$store.state.user!='' && $store.state.user!=null && (new Date($store.state.vencimiento))>(new Date())" @click="menu=!menu"></v-app-bar-nav-icon>
      <v-app-bar-title>
        <div class="d-flex align-center">
          <a href="http://ivt.edu.ar/">
            <v-img
              alt="IVT"
              class="shrink mr-2"
              contain
              src="http://ivt.edu.ar/wp-content/uploads/2021/02/Logo-IVT-final.png"
              transition="scale-transition"
              width="60"
            />
          </a>
          INSTITUTO VISIÓN TECNOLÓGICA
        </div>
      </v-app-bar-title>
    </v-app-bar>
    <v-navigation-drawer v-if="$store.state.user!='' && $store.state.user!=null && (new Date($store.state.vencimiento))>(new Date())" app v-model="menu" temporary width="auto" >
      <v-list class="pa-5">
        <v-list-tile avatar class="alineacentro">
          <v-row>
            <v-col cols="12" md="1" lg="1" class="alineacentro">
              <v-list-item-avatar>
                <img :src="fotouser" />
                <!--<img src="https://randomuser.me/api/portraits/men/85.jpg">-->
              </v-list-item-avatar>
            </v-col>
            <v-col class="alineacentro" cols="10" md="9" lg="9">
              <v-list-tile-content class="alineacentro">
                <v-list-item-title class="textoNegrita">{{$store.state.username}}</v-list-item-title>
                <v-list-item-title class="textoChicoNegrita">({{$store.state.user}})</v-list-item-title>
                <!-- <v-list-item-subtitle>{{$store.state.rolusuario}}</v-list-item-subtitle> -->
              </v-list-tile-content>
            </v-col>
            <v-col cols="2" md="2" lg="2" class="alineacentro">
              <v-btn
                icon
                color="grey"
                @click="menu=false"
              >
                <v-icon size="24px">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <div v-if="$store.state.rolesuserid.includes(3) || $store.state.rolesuserid.includes(4) || $store.state.rolesuserid.includes(5) || $store.state.rolesuserid.includes(99)">
          <div v-for="item in itemsadmin" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesuserid.includes(1)">
          <div v-for="item in itemsalumno" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesuserid.includes(2)">
          <div v-for="item in itemsdocente" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesuserid.includes(100) && !$store.state.rolesuserid.includes(1)">
          <div v-for="item in itemsuser" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <v-list-item>
          <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
          <v-list-item-content>
            <v-btn
              color="primary"
              text
              @click="logout()"
            >Cerrar Sesión
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main color="primary" dark>
      <router-view/>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>
<script>
import Footer from "./components/Footer.vue";
export default {
  name: 'App',
  components: {
    Footer: Footer
  },
  data: () => ({
    fotouser: '',
    /*items:
     [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Carrera', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncarrera',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              },
              {
                link: '/matriculacion',
                title: 'Matriculación',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Cursadas', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncursada',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Exámenes Finales', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/adminmesasexafinal',
                title: 'Administración de Mesas',
                icon: 'mdi-home-city'
              }
            //   {
            //     link: '/cuotaanual',
            //     title: 'Cuota Anual',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/adminmatriculados',
            //     title: 'Fichero',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/consultamatriculados',
            //     title: 'Consulta de Matriculados',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/listadosmatriculados',
            //     title: 'Listados de Matriculados',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/deudamatriculados',
            //     title: 'Carga de Deuda de Matriculados',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/conveniopago',
            //     title: 'Convenio de Pago',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/tramitesmorosidad',
            //     title: 'Trámites de Morosidad',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/certificadomatricula',
            //     title: 'Certificados de Matrícula',
            //     icon: 'mdi-home-city'
            //   },
            //   {
            //     link: '/infsaldosmatriculados',
            //     title: 'Informes de Saldos',
            //     icon: 'mdi-home-city',
            //   },
            //   {
            //     link: '/infantsaldoscc',
            //     title: 'Informes de Antiguedad de Saldos de Cuenta Corriente',
            //     icon: 'mdi-home-city',
            //   },
            //   {
            //     link: '/infmovmatriculados',
            //     title: 'Informes de Movimientos por Matriculado',
            //     icon: 'mdi-home-city',
            //   },
            //   {
            //     link: '/infvencdebmatriculado',
            //     title: 'Informe de Vencimientos de Débitos de Matriculados',
            //     icon: 'mdi-home-city',
            //   }
            ]
          },
          { title: 'Comprobantes', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/facturas',
                title: 'Facturas',
                icon: 'mdi-home-city'
              },
              {
                link: '/recibos',
                title: 'Recibos',
                icon: 'mdi-home-city'
              }
            ]
          },
    ], */
    menu: false,
    usuario: '',
    itemsadmin: [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Carrera', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncarrera',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              },
              {
                link: '/matriculacion',
                title: 'Matriculación',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Administración', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/gestioncuota',
                title: 'Gestión de Cuotas',
                icon: 'mdi-home-city'
              },
              {
                link: '/ficheroalumno',
                title: 'Fichero de Estudiantes',
                icon: 'mdi-home-city'
              },
              {
                link: '/adminmovimientoscc',
                title: 'Administración de Movimientos de CC de Estudiantes',
                icon: 'mdi-home-city'
              },
            ]
          },
          { title: 'Comprobantes', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/facturas',
                title: 'Facturas',
                icon: 'mdi-home-city'
              },
              {
                link: '/recibos',
                title: 'Recibos',
                icon: 'mdi-home-city'
              },
              {
                link: '/importarpagofacil',
                title: 'Importar Pago Fácil',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Reportes', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/certificadoalumno',
                title: 'Certificados del Estudiante',
                icon: 'mdi-home-city'
              },
              {
                link: '/listadocursadas',
                title: 'Listado de Cursadas',
                icon: 'mdi-home-city'
              },
              {
                link: '/reportedeudaxdivision',
                title: 'Deuda por División',
                icon: 'mdi-home-city'
              },
              {
                link: '/reportedeudaxcarrerasedeanio',
                title: 'Deuda por Carrera Sede y Año',
                icon: 'mdi-home-city'
              },
              {
                link: '/listadocomprobantes',
                title: 'Listado de Comprobantes',
                icon: 'mdi-home-city'
              }
              ,{
                link: '/listadoalumnosdiv',
                title: 'Listado Alumnos por División para Parcial',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Cursadas', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncursada',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              },
              {
                link: '/asistenciaalumno',
                title: 'Asistencia de Estudiantes',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Exámenes Finales', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/adminmesasexafinal',
                title: 'Administración de Mesas',
                icon: 'mdi-home-city'
              }
            ]
          },
    ],
    itemsdocente: [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Cursadas', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/asistenciaalumno',
                title: 'Asistencia de Estudiantes',
                icon: 'mdi-home-city'
              }
            ]
          },
    ],
    itemsalumno: [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Carrera', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncarrera',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Cursadas', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncursada',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Gestión de Cuotas', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/alumnocuota',
                title: 'Ver o Imprimir Facturas',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Reportes', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/certificadoalumno',
                title: 'Certificados del Estudiante',
                icon: 'mdi-home-city'
              },
            ]
          }
    ],
    itemsuser: [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Carrera', icon: 'mdi-file-document-check-outline', link: '',
            subLinks: [
              {
                link: '/inscripcioncarrera',
                title: 'Inscripción',
                icon: 'mdi-home-city'
              }
            ]
          }
    ],
  }),
  mounted() {
      this.fotouser= localStorage.getItem('foto');
      this.usuario= localStorage.getItem("user");
  },
  methods:{
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.menu= false
        this.$router.push('/')
      })
    },
  },
  created: function () {
    this.$http.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status === 401) {
        if (this.$store.getters.authorized) {
          this.$store.dispatch('refreshtoken')
        } else {
          return Promise.reject(error)
        }
      } else {
        return Promise.reject(error)
      }
    })
  },
};
</script>
<style>
.v-list-item__title, .v-list-item__subtitle {
    flex: unset !important; /* 1 1 100%;*/
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color:red !important;
  font-weight:bold !important;
}
.textoNegritaVerde{
  color:rgb(83, 248, 125) !important;
  font-weight:bold !important;
}
.textoNegrita {
  font-weight:bold !important;
}
.textoChicoNegrita {
  font-weight:bold !important;
  font-size: small !important;
}
</style>
<style>
.Titulo {
    font-family: Verdana;
    font-size: 12pt !important;

}

.TituloAlto {
    height: 40px;
}

.titulocardchico {
    padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa15 {
  width: 15%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: dimgray;
}
.textoNegritaRojo {
  color:red !important;
  font-weight:bold !important;
}
.textoNegrita {
  font-weight:bold !important;
}
.textoNegritaTitulo {
  font-weight:bold !important;
  font-size: medium;
}
.textoNegritaVerde{
  color:rgb(83, 248, 125) !important;
  font-weight:bold !important;
}
.container {
    max-width: unset !important;
}
</style>